import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { CONTENT_DATA } from './data';

import { useDispatch, useSelector } from 'react-redux';
import { updateCookiePreference } from '@/redux/cookieSlice';
import { IOSSwitch } from './Switch';

const CustomAccordion = styled(Accordion)(() => ({
  backgroundColor: 'transparent',
  color: '#1a1a1a',
  boxShadow: 'none',
  '&:before': {
    display: 'none'
  },
  '&.Mui-expanded': {
    margin: 0,
    backgroundColor: '#F8FAFC'
  },
  borderBottom: '1px solid #f1f5f9'
}));

const CustomAccordionSummary = styled(AccordionSummary)(() => ({
  padding: '0 16px',
  minHeight: 56,
  position: 'relative',
  '&.Mui-expanded': {
    minHeight: 56,
    backgroundColor: '#F8FAFC',
    borderLeft: '4px solid #3B82F6'
  },
  '& .MuiAccordionSummary-content': {
    margin: '12px 0',
    '&.Mui-expanded': {
      margin: '12px 0'
    }
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: '#334155'
  },
  fontSize: '15px'
}));

const CustomAccordionDetails = styled(AccordionDetails)(() => ({
  padding: '0 16px 16px'
}));

export default function CookieMobileContent() {
  const [expanded, setExpanded] = React.useState<string | false>('panel0');
  const dispatch = useDispatch();
  const preferences = useSelector((state: any) => state.cookie.preferences);

  const getSwitchValue = (item: any) => {
    if (item.name && preferences[item.name] !== undefined) {
      return preferences[item.name];
    }
    return item.needConfirm === 2;
  };

  const handleSwitchChange = (item: any, checked: boolean) => {
    if (item.name) {
      dispatch(updateCookiePreference({ type: item.name, value: checked }));
    }
  };

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <Box className="h-[calc(100%_-_130px)] w-full overflow-y-auto pb-4">
      {CONTENT_DATA.map((item, index) => (
        <CustomAccordion
          key={item.title}
          expanded={expanded === `panel${index}`}
          onChange={handleChange(`panel${index}`)}
        >
          <CustomAccordionSummary
            aria-controls={`panel${index}-content`}
            id={`panel${index}-header`}
          >
            <div className="flex w-full items-center justify-between pr-2">
              <Typography
                sx={{
                  fontSize: '16px',
                  fontWeight: expanded === `panel${index}` ? 600 : 400,
                  color: '#1a1a1a'
                }}
              >
                {item.title}
              </Typography>
              <div onClick={(e) => e.stopPropagation()}>
                {item.needConfirm === 1 ? (
                  <span className="text-sm text-[#4F46E5]">Always Active</span>
                ) : item.needConfirm === 2 ? (
                  <IOSSwitch
                    checked={getSwitchValue(item)}
                    onChange={(e) => handleSwitchChange(item, e.target.checked)}
                  />
                ) : null}
              </div>
            </div>
          </CustomAccordionSummary>
          <CustomAccordionDetails>
            <div className="text-sm text-[#64748b] leading-relaxed">
              {item.content}
            </div>
          </CustomAccordionDetails>
        </CustomAccordion>
      ))}
    </Box>
  );
}
